module.exports = __webpack_public_path__ + "img/feature-app-image1.bf1718ea.png";